import NbaAllTeams from "@/services/NbaAllTeam.js";
import common from "@/services/common";
import axios from "axios";
import _ from "lodash";

const state = () => ({
    AllUsers: [],
    AllSlate: [],
    buildTeam: [],
    cloneTeam: [],
    customerSession: [],
    exposure: [],
    forgetPass: null,
    fullStats: [],
    getTeamStatus: false,
    LineupBuild: [],
    loadingStatus: false,
    nba_props: [],
    nbaplayerDetailLoader: false,
    operator: "",
    operatorGameType: "",
    playersDetail: [],
    playerPerTeam: "",
    // playerInfo: [],
    playerReset: [],
    playerTrends: [],
    playerSwap: [],
    portal: [],
    position: "",
    premiumFilterList: [],
    registerData: [],
    savedLineup: [],
    saveBuild: [],
    scoring: [],
    setTopPlaysData: [],
    status: true,
    Teams: [],
    teamBuildStatus: false,
    TeamStack: [],
    teamInfo: [],
    topPlayers: [],
    topPlaysStatus: false,
    TopStudAndValues: [],
    user: null,
    userLoader: false,
    otp: [],
    verification: [],
    injuries: [],
    depthChart: [],
    upcomingGames: [],
    processInfo: [],
    lastActivity: [],
    daily_lineups: [],
    nbaNews: [],
});

const mutations = {
    SET_OTP(state, data) {
        state.otp = data;
    },

    SET_VERIFICATION(state, data) {
        state.verification = data;
    },

    SET_EXPOSURE(state, data) {
        if (state.operator == "FanDuel" && state.operatorGameType == "Single") {
            state.exposure.push(data);
            // console.log('exposure nba Fd', state.exposure);
        } else {
            state.exposure.push(data);
            // console.log('exposure nba', state.exposure);
        }
    },

    REMOVE_EXPOSURE(state) {
        if (state.operator == "FanDuel" && state.operatorGameType == "Single") {
            state.exposure = [];
            //console.log('exposure remove nba', state.exposure);
        }
        return;
    },

    SET_TOP_PLAYS(state, data) {
        state.setTopPlaysData = data;
        //console.log('top plays: ', state.setTopPlaysData);
    },

    SHOW_TOP_PLAYS(state, data) {
        state.topPlayers = data;
    },

    SHOW_PREMIUM_FILTER(state, data) {
        state.premiumFilterList = data;
    },

    // SET_USER_REGISTER(state, data) {
    //   state.registerData = data;
    //   console.log('data', data);
    // },

    SET_USER_DATA(state, data) {
        state.user = data;
        console.log(state.user);
        if (state.user.success) {
            localStorage.setItem("user", data.data._id);
            localStorage.setItem("userName", data.data.userName);
            localStorage.setItem("role", data.data.role);
            localStorage.setItem("radio", "classic");
            localStorage.setItem("status", data.data.status);
            localStorage.setItem("stripe_customer_id", data.data.stripe_Customer_id);
            localStorage.setItem("paymentType", data.data.paymentType);
            // localStorage.setItem('email', data.data.email);
            localStorage.setItem("isBanner", data.data.isBanner);
            localStorage.setItem("planType", data.data.plantype)
            localStorage.setItem(
                "stripe_Subscription_id",
                data.data.stripe_Subscription_id
            );
            localStorage.setItem("loginTimestamp", Date.now().toString());
        }
    },

    SET_FORGET_PASSWORD(state, data) {
        state.forgetPass = data;
    },

    SET_CUSTOMER_SESSION(state, data) {
        state.customerSession = data;
        // console.log('Stripe session', data);
    },

    SET_PORTAL_DATA(state, data) {
        state.portal = data;
        //console.log('portal', state.portal);
    },

    CLEAR_USER_DATA(state) {
        state.user = null;
        localStorage.clear();
        // axios.defaults.headers.common['Authorization'] = null;
    },

    SET_TEAMS(state, teams) {
        state.Teams = teams;
    },

    SET_INJURIES(state, data) {
        state.injuries = data;
    },

    SET_DEPTHCHART(state, data) {
        state.depthChart = data;
    },

    SET_UPCOMINGGAMES(state, data) {
        state.upcomingGames = data;
    },

    SET_CLONE(state, clone) {
        state.cloneTeam = {...clone};
    },

    SET_LOADING(state, newLoadingStatus) {
        state.loadingStatus = newLoadingStatus;
    },

    SET_PLAYERDETAIL_LOADER(state, loader) {
        state.nbaplayerDetailLoader = loader;
    },

    SET_TEAM_LOADER(state, loader) {
        state.getTeamStatus = loader;
    },

    SET_USER_LOADER(state, loader) {
        state.userLoader = loader;
    },

    SET_BUILD_TEAM_LOADER(state, status) {
        state.teamBuildStatus = status;
    },
    SET_TOP_PLAYS_LOADER(state, status) {
        state.topPlaysStatus = status;
    },

    SET_SLATE(state, slate) {
        state.AllSlate = slate;
        // //console.log("allSlate", typeof state.AllSlate, state.AllSlate);
    },

    SET_USER_PLAN(state, data) {
        this.state.userModule.userState = data;
    },

    SLATE_STATUS(state, status) {
        state.status = status;
    },

    SET_PLAYER(state, playerDetail) {
        // state.playersDetail = [];
        state.playersDetail = playerDetail;
        // //console.log("player nba", typeof state.playersDetail, state.playersDetail);
    },
    SET_BUILD_TEAM(state, buildTeam) {
        state.buildTeam = buildTeam;
        // //console.log("build teams", state.buildTeam);
    },
    SET_TEAM_STACK(state, teamStack) {
        state.TeamStack = teamStack;
    },
    SET_SAVE_LINEUP(state, lineup) {
        state.savedLineup = lineup;
    },
    SET_SAVE_BUILD(state, saveBuild) {
        state.saveBuild = saveBuild;
        // //console.log("build", state.saveBuild.doc[0]._id);
    },
    SET_LINE_Up_BUILD(state, lineupBuild) {
        state.LineupBuild = lineupBuild;
    },

    SET_TEAM_DETAIL(state, info) {
        state.teamInfo = info;
        //console.log('teamInfo', typeof state.teamInfo, state.teamInfo);
    },
    SET_RESET_PLAYERS(state, resetData) {
        state.playerReset = resetData;
        // //console.log(state.playerReset);
    },
    SET_PLAYER_PER_TEAM(state, playerPerTeamData) {
        state.playerPerTeam = playerPerTeamData.teamStack.some((element) => {
            return element.minNoOfPlayer > 0;
        });
        //console.log('playerPerTeam', state.playerPerTeam);
    },

    SET_TOP_PLAYERS(state, data) {
        state.TopStudAndValues = data;
        //console.log('top players', state.TopStudAndValues);
    },

    SET_PLAYER_TRENDs(state, data) {
        state.playerTrends = data;
    },

    SET_FULL_STAT(state, data) {
        state.fullStats = data;
    },

    SET_SCORING(state, data) {
        state.scoring = data;
    },
    SET_PLAYER_SWAP(state, swapData) {
        state.playerSwap = swapData;
    },

    SET_ALL_USERS(state, data) {
        state.AllUsers = data;
    },

    SET_PROCESS_INFO(state, info) {
        state.processInfo = info;
    },

    SET_LAST_ACTIVITY(state, data) {
        state.lastActivity = data;
        console.log("last activity", data);
    },

    SET_NBA_PROPS(state, data) {
        state.nba_props = data;
    },

    SET_DAILY_LINEUP(state, data) {
        state.daily_lineups = data;
    },

    SET_NBA_NEWS(state, data) {
        state.nbaNews = data;
    },
};

const actions = {
    async getProcessInfo({commit}) {
        try {
            const response = await common.fetchProcessInfo();
            let parseData = JSON.parse(response.data.processInfo);
            console.log("parseData", parseData);
            commit("SET_PROCESS_INFO", parseData);
        } catch (error) {
            console.error(error);
        }
    },

    async userRegister({commit, dispatch}, credential) {
        await axios
            .post("https://api.fantasylineups.com/user/register", credential)
            .then((res) => {
                if (res.data.success) {
                    commit("SET_USER_DATA", res.data);
                    const notification = {
                        type: "success",
                        message: "Successfully Registration: ",
                    };
                    dispatch("notification/add", notification, {root: true});
                } else {
                    commit("SET_USER_DATA", res.data);
                    const notification_1 = {
                        type: "error",
                        message: `${res.data.message}`,
                    };
                    dispatch("notification/add", notification_1, {root: true});
                }
            })
            .catch((err) => {
                const notification_2 = {
                    type: "error",
                    message: "There was an error with Registration: " + err.message,
                };
                dispatch("notification/add", notification_2, {root: true});
                throw err;
            });
    },

    async resetPassword({commit, dispatch}, credential) {
        await axios
            .post("https://api.fantasylineups.com/user/resetPassword", credential)
            .then((res) => {
                if (res.data.success) {
                    commit("SET_FORGET_PASSWORD", res.data);
                    const notification = {
                        type: "success", message: "Successfully reset password,Now login with new credential.",
                    };
                    dispatch("notification/add", notification, {root: true});
                } else {
                    const notification_1 = {
                        type: "error", message: "There was an error with confirming new password, please recheck.",
                    };
                    dispatch("notification/add", notification_1, {root: true});
                }
            })
            .catch((err) => {
                const notification_2 = {
                    type: "error",
                    message: "There was an error with Forgot password: " + err.message,
                };
                dispatch("notification/add", notification_2, {root: true});
                throw err;
            });
    },

    async userLogin({commit, dispatch}, credential) {
        await axios
            .post("https://api.fantasylineups.com/user/login", credential)
            .then((res) => {
              if (res.data.success) {
                commit("SET_USER_DATA", res.data);
                const notification = {
                  type: "success",
                  message:
                      `Welcome back! Your ${res.data.data.plantype || 'NO'} plan is active.`,
                };
                dispatch("notification/add", notification, { root: true });
              } else {
                const notification_1 = {
                  type: "error",
                  message:res.data.message,
                };
                dispatch("notification/add", notification_1, { root: true });
              }
            })
            .catch((err) => {
                const notification = {
                    type: "error",
                    message: "There was an error with Login: " + err.message,
                };
                dispatch("notification/add", notification, {root: true});
                throw err;
            });
    },

    async createSession({commit, dispatch}, payload) {
        await axios
            .post("https://api.fantasylineups.com/user/createsession", payload)
            .then((res) => {
                if (res.data.message === "Already Subscribed ") {
                    const notification = {
                        type: "info",
                        message: "Already Subscribed",
                    };
                    dispatch("notification/add", notification, {root: true});
                } else if (!res.data.success) {
                    console.log(res);
                    const notification = {
                        type: "error",
                        message: res.data.message,
                    };
                    dispatch("notification/add", notification, {root: true});
                } else {
                    commit("SET_CUSTOMER_SESSION", res.data);
                    const notification = {
                        type: "success",
                        message: "Created session Successfully.",
                    };
                    dispatch("notification/add", notification, {root: true});
                }
            })
            .catch((err) => {
                const notification = {
                    type: "error",
                    message: "There was an error with payment: " + err.message,
                };
                dispatch("notification/add", notification, {root: true});
                throw err;
            });
    },

    async createPortal({commit, dispatch}, payload) {
        commit("SET_TEAM_LOADER", true);
        await axios
            .post("https://api.fantasylineups.com/user/createportal", payload)
            .then((res) => {
                if (res.data.success == false) {
                    const notification_1 = {
                        type: "error",
                        message: "Something went wrong, Try again later.",
                    };
                    dispatch("notification/add", notification_1, {root: true});
                } else {
                    commit("SET_PORTAL_DATA", res.data);
                    commit("SET_TEAM_LOADER", false);
                    const notification = {
                        type: "success",
                        message: "Going to Portal...",
                    };
                    dispatch("notification/add", notification, {root: true});
                }
            })
            .catch((err) => {
                const notification = {
                    type: "error",
                    message: "There was an error with showing Billing : " + err.message,
                };
                dispatch("notification/add", notification, {root: true});
                throw err;
            });
    },

    userLogout({commit}) {
        commit("CLEAR_USER_DATA");
    },

    async SetExposure({commit, dispatch}, values) {
        await NbaAllTeams.setExposure(values)
            .then((res) => {
                if (res.data.success == false) {
                    const notification_1 = {
                        type: "error",
                        message: res.data.message,
                    };
                    dispatch("notification/add", notification_1, {root: true});
                } else {
                    commit("SET_EXPOSURE", res.data.doc);
                }
            })
            .catch((err) => {
                const notification_2 = {
                    type: "error",
                    message: "There was an error with SetExposure: " + err.message,
                };
                dispatch("notification/add", notification_2, {root: true});
            });
    },

    async SetTopPlays({commit, dispatch}, payload) {
        try {
            const res = await NbaAllTeams.setTopPlays(payload);
            commit("SET_TOP_PLAYS", res.data);
        } catch (err) {
            const notification = {
                type: "error",
                message: "There was an error with setting up top players" + err.message,
            };
            dispatch("notification/add", notification, {root: true});
        }
    },

    async GetTopPlays({commit, dispatch}, payload) {
        commit("SET_TOP_PLAYS_LOADER", true);
        try {
            const res = await NbaAllTeams.getTopPlays(payload);
            commit("SHOW_TOP_PLAYS", res.data);
            commit("SET_TOP_PLAYS_LOADER", false);
            const notification = {
                type: "success",
                message: "Player update successfully.",
            };
            dispatch("notification/add", notification, {root: true});
        } catch (err) {
            const notification_1 = {
                type: "error",
                message: "There was an error with showing up top players" + err.message,
            };
            dispatch("notification/add", notification_1, {root: true});
        }
    },

    GetPremiumFilterList({commit, dispatch}, payload) {
        // commit('SET_TOP_PLAYS_LOADER', true);
        NbaAllTeams.getPremiumFilters(payload)
            .then((res) => {
                commit("SHOW_PREMIUM_FILTER", res.data);
                // commit('SET_TOP_PLAYS_LOADER', false);
            })
            .catch((err) => {
                const notification_1 = {
                    type: "error",
                    message:
                        "There was an error with showing up premium filters" + err.message,
                };
                dispatch("notification/add", notification_1, {root: true});
            });
    },

    async unlockPlayers({dispatch}, payload) {
        await NbaAllTeams.unlockPlayer(payload)
            .then(() => {
            })
            .catch((err) => {
                const notification = {
                    type: "error",
                    message: "There was an error with Unlock Player: " + err.message,
                };
                dispatch("notification/add", notification, {root: true});
            });
    },

    async resetPlayers({commit, dispatch}, payload) {
        commit("SET_LOADING", true);
        await NbaAllTeams.resetPlayers(payload)
            .then((res) => {
                commit("SET_RESET_PLAYERS", res.data);
                commit("REMOVE_EXPOSURE");
                commit("SET_LOADING", false);
                const notification = {
                    type: "success",
                    message: "Players has been reset.",
                };
                dispatch("notification/add", notification, {root: true});
            })
            .catch((err) => {
                const notification_1 = {
                    type: "error",
                    message: "There was an error with reset players: " + err.message,
                };
                dispatch("notification/add", notification_1, {root: true});
                throw err;
            });
    },

    async getTeams({commit, dispatch}, payload) {
        commit("SET_TEAM_LOADER", true);
        try {
            const res = await NbaAllTeams.getAllTeams(payload);
            commit("SET_TEAMS", res.data); //* this will responsible to change the actual state not the action method...
            commit("SET_CLONE", res.data);
            commit("SET_TEAM_LOADER", false);
        } catch (err) {
            const notification = {
                type: "error",
                message: "There was an error with Get All Teams: " + err.message,
            };
            dispatch("notification/add", notification, {root: true});
        }
    },

    async getInjuries({commit}, payload) {
        // commit('SET_TEAM_LOADER', true);
        try {
            const res = await NbaAllTeams.getInjuries(payload);
            commit("SET_INJURIES", res.data); //* this will responsible to change the actual state not the action method...
            // commit('SET_TEAM_LOADER', false);
        } catch (err) {
            return console.error(
                "There was an error with getting Injuries:" + err.message
            );
        }
    },

    async getDepth({commit}, payload) {
        // commit('SET_TEAM_LOADER', true);
        try {
            const res = await NbaAllTeams.getDepthChart(payload);
            commit("SET_DEPTHCHART", res.data); //* this will responsible to change the actual state not the action method...
            // commit('SET_TEAM_LOADER', false);
        } catch (err) {
            return console.error(
                "There was an error with getting depthChart:" + err.message
            );
        }
    },

    async getUpcomingGames({commit}, payload) {
        // commit('SET_TEAM_LOADER', true);
        try {
            const res = await NbaAllTeams.getUpcomingGames(payload);
            commit("SET_UPCOMINGGAMES", res.data); //* this will responsible to change the actual state not the action method...
            // commit('SET_TEAM_LOADER', false);
        } catch (err) {
            return console.error(
                "There was an error with getting upcomingGames:" + err.message
            );
        }
    },

    //* update user info by admin...

    async getAllUsers({commit, dispatch}) {
        commit("SET_USER_LOADER", true);
        try {
            const res = await NbaAllTeams.getAllUsers();
            commit("SET_ALL_USERS", res.data);
            commit("SET_USER_LOADER", false);
        } catch (error) {
            const notification = {
                type: "error",
                message: "There was an error with Get All User: " + error.message,
            };
            dispatch("notification/add", notification, {root: true});
        }
    },

    async deleteUser({dispatch}, payload) {
        try {
            const res = await NbaAllTeams.getUserDelete(payload);
            if (res.data.success) {
                const notification = {
                    type: "success",
                    message: "User deleted successfully.",
                };
                dispatch("notification/add", notification, {root: true});
            } else {
                const notification_1 = {
                    type: "error",
                    message:
                        "There was an error while deleting user, please try after few minutes..",
                };
                dispatch("notification/add", notification_1, {root: true});
            }
        } catch (error) {
            const notification_2 = {
                type: "error",
                message: "There was an error : " + error.message,
            };
            dispatch("notification/add", notification_2, {root: true});
        }
    },

    async updateUserPassword({dispatch}, payload) {
        try {
            const res = await NbaAllTeams.updateUserPassword(payload);
            if (res.data.success) {
                const notification = {
                    type: "success",
                    message: "User password updated successfully.",
                };
                dispatch("notification/add", notification, {root: true});
            } else {
                const notification_1 = {
                    type: "info",
                    message:
                        "There was an error while updating user password, please try after few minutes..",
                };
                dispatch("notification/add", notification_1, {root: true});
            }
        } catch (error) {
            const notification_2 = {
                type: "error",
                message: "There was an error : " + error.message,
            };
            dispatch("notification/add", notification_2, {root: true});
        }
    },
    //* update user info by admin ends...

    //* cancel subscription by admin...
    async cancelSubscription({dispatch}, payload) {
        try {
            const res = await common.cancelSubscription(payload);
            console.log("res", res.data);
            if (res.data.success) {
                const notification = {
                    type: "success",
                    message: "Subscription cancelled successfully.",
                };
                dispatch("notification/add", notification, {root: true});
            }
        } catch (error) {
            const notification_1 = {
                type: "info",
                message:
                    "There was an error while canceling the subscription, please try again..",
            };
            dispatch("notification/add", notification_1, {root: true});
        }
    },
    //* cancel subscription by admin ends...

    // * user last activity status...
    async userLastActivity({dispatch, commit}, payload) {
        try {
            const res = await common.userLastActivity(payload);
            commit("SET_LAST_ACTIVITY", res.data);
            if (res.data.success) {
                const notification = {
                    type: "success",
                    message: "Subscription cancelled successfully.",
                };
                dispatch("notification/add", notification, {root: true});
            }
        } catch (error) {
            const notification_1 = {
                type: "info",
                message: "Data not available, please try again..",
            };
            dispatch("notification/add", notification_1, {root: true});
        }
    },
    // * user last activity status...

    // * recover password via otp..
    async forgetPassword({commit, dispatch}, payload) {
        try {
            const res = await NbaAllTeams.forgetPassword(payload);
            if (res.data.success) {
                commit("SET_OTP", res.data);
                const notification = {
                    type: "success",
                    message: "OTP sent successfully.",
                };
                dispatch("notification/add", notification, {root: true});
            } else {
                const notification_1 = {
                    type: "info",
                    message:
                        "There was an error while recovering user password, please try after few minutes.",
                };
                dispatch("notification/add", notification_1, {root: true});
            }
        } catch (error) {
            const notification_2 = {
                type: "error",
                message: "There was an error : " + error.message,
            };
            dispatch("notification/add", notification_2, {root: true});
        }
    },
    // * recover password via otp ends...

    async verifyOTP({commit, dispatch}, payload) {
        try {
            const res = await NbaAllTeams.verifyOtp(payload);
            if (res.data.success) {
                commit("SET_VERIFICATION", res.data);
                const notification = {
                    type: "success",
                    message: "Password reset successfully.",
                };
                dispatch("notification/add", notification, {root: true});
            } else {
                const notification_1 = {
                    type: "info",
                    message:
                        "There might be a chance that your OTP got expired, please request a new one.",
                };
                dispatch("notification/add", notification_1, {root: true});
            }
        } catch (error) {
            const notification_2 = {
                type: "error",
                message: "There was an error : " + error.message,
            };
            dispatch("notification/add", notification_2, {root: true});
        }
    },

    // * recover password via otp ends..

    async getSlate({commit, dispatch}, payload) {
        commit("SET_LOADING", true);
        await NbaAllTeams.getAllSlate(payload || localStorage.getItem("user"))
            .then((res) => {
                commit("SET_SLATE", res.data.data);
                commit("SLATE_STATUS", res.data.success);
                if (res.data.success) {
                    const notification_1 = {
                        type: "success",
                        message: "Success",
                    };
                    dispatch("notification/add", notification_1, {root: true});
                    commit("SET_USER_PLAN", res.data.userData);
                }
                commit("SET_LOADING", false);
            })
            .catch((err) => {
                const notification = {
                    type: "error",
                    message: "There was an error with Get All Slates: " + err.message,
                };
                dispatch("notification/add", notification, {root: true});
            });
    },

    async getPlayer({commit, dispatch}, payload) {
        commit("SET_LOADING", true);
        return await NbaAllTeams.getPlayersDetails(payload)
            .then((res) => {
                commit("SET_PLAYER", res.data.data);
                commit("SET_LOADING", false);
            })
            .catch((err) => {
                const notification = {
                    type: "error",
                    message: "There was an error with Get Players: " + err.message,
                };
                dispatch("notification/add", notification, {root: true});
            });
    },

    async getBuildTeam({commit, dispatch}, params) {
        commit("SET_BUILD_TEAM_LOADER", true);
        await NbaAllTeams.getTeamBuild(params)
            .then((res) => {
                commit("SET_BUILD_TEAM", res.data);
                commit("SET_BUILD_TEAM_LOADER", false);
                if (res.data.status == 1 || res.data.allTeams.length == 0) {
                    const notification = {
                        type: "error",
                        message: "No Lineup has been created!!",
                    };
                    return dispatch("notification/add", notification, {root: true});
                } else {
                    const notification_1 = {
                        type: "success",
                        message: "Team has been Created.",
                    };
                    return dispatch("notification/add", notification_1, {root: true});
                }
            })
            .catch((err) => {
                console.error(err);
                const notification = {
                    type: "error",
                    message: "There was an error with Get Build Teams",
                };
                dispatch("notification/add", notification, {root: true});
            });
    },

    getTeamStack({commit, dispatch}, slateId) {
        commit("SET_LOADING", true);
        NbaAllTeams.getTeamStack(slateId)
            .then((res) => {
                commit("SET_TEAM_STACK", res.data);
                commit("SET_LOADING", false);
            })
            .catch((err) => {
                const notification = {
                    type: "error",
                    message: "There was an error with Get Team Stack: " + err.message,
                };
                dispatch("notification/add", notification, {root: true});
            });
    },

    getPlayerPerTeam({commit, dispatch}, TeamDetails) {
        commit("SET_LOADING", true);
        NbaAllTeams.playerPerTeam(TeamDetails)
            .then((res) => {
                commit("SET_PLAYER_PER_TEAM", res.data.result);
                commit("SET_LOADING", false);
            })
            .catch((err) => {
                const notification = {
                    type: "error",
                    message:
                        "There was an error with Get Player per team: " + err.message,
                };
                dispatch("notification/add", notification, {root: true});
            });
    },

    getSaveLineup({commit, dispatch}, buildTeam) {
        commit("SET_BUILD_TEAM_LOADER", true);
        NbaAllTeams.savedLineup(buildTeam)
            .then((res) => {
                commit("SET_SAVE_LINEUP", res.data.doc);
                commit("SET_BUILD_TEAM_LOADER", false);
                const notification = {
                    type: "success",
                    message: "Build saved!",
                };
                dispatch("notification/add", notification, {root: true});
            })
            .catch((err) => {
                const notification_1 = {
                    type: "error",
                    message: "There was an error with Get save Lineup.: " + err.message,
                };
                dispatch("notification/add", notification_1, {root: true});
            });
    },

    async getSavedBuild({commit, dispatch}, payload) {
        commit("SET_LOADING", true);
        await NbaAllTeams.getAllBuild(payload)
            .then((res) => {
                commit("SET_SAVE_BUILD", res.data);
                commit("SET_LOADING", false);
            })
            .catch((err) => {
                const notification = {
                    type: "error",
                    message: "There was an error with Get Build Teams: " + err.message,
                };
                dispatch("notification/add", notification, {root: true});
                throw err;
            });
    },

    async getLineUpBuild({commit, dispatch}, id) {
        commit("SET_BUILD_TEAM_LOADER", true);
        await NbaAllTeams.getLineUp(id)
            .then((res) => {
                commit("SET_LINE_Up_BUILD", res.data);
                commit("SET_BUILD_TEAM_LOADER", false);
            })
            .catch((err) => {
                const notification = {
                    type: "error",
                    message: "There was an error with Get Lineup: " + err.message,
                };
                dispatch("notification/add", notification, {root: true});
            });
    },

    async getTeamDetails({commit, dispatch}, payload) {
        commit("SET_LOADING", true);
        await NbaAllTeams.teamDetails(payload)
            .then((res) => {
                //  ;
                commit("SET_TEAM_DETAIL", res.data);
                commit("SET_LOADING", false);
            })
            .catch((err) => {
                const notification = {
                    type: "error",
                    message: "There was an error with Get Team Details: " + err.message,
                };
                dispatch("notification/add", notification, {root: true});
            });
    },

    async GetPlayerFullStats({commit, dispatch}, payload) {
        commit("SET_PLAYERDETAIL_LOADER", true);
        try {
            const res = await NbaAllTeams.getFullStat(payload);
            commit("SET_FULL_STAT", res.data);
            commit("SET_PLAYERDETAIL_LOADER", false);
        } catch (err) {
            const notification_1 = {
                type: "error",
                message: "There was an error with fetching full stats: " + err.message,
            };
            dispatch("notification/add", notification_1, {root: true});
        }
    },

    async GetTopPlayers({commit, dispatch}, payload) {
        commit("SET_LOADING", true);
        try {
            const res = await NbaAllTeams.getTopPlayers(payload);
            commit("SET_TOP_PLAYERS", res.data);
            commit("SET_LOADING", false);
        } catch (err) {
            const notification_1 = {
                type: "error",
                message: "There was an error with fetching top players: " + err.message,
            };
            dispatch("notification/add", notification_1, {root: true});
        }
    },

    FetchPlayerTrends({commit, dispatch}, payload) {
        commit("SET_TEAM_LOADER", true);
        NbaAllTeams.getPlayerTrend(payload)
            .then((res) => {
                commit("SET_PLAYER_TRENDs", res.data.data);
                commit("SET_TEAM_LOADER", false);
                // const notification = {
                //   type: 'success',
                //   message: 'Player trends successfully loaded.',
                // };
                // dispatch('notification/add', notification, { root: true });
            })
            .catch((err) => {
                const notification_1 = {
                    type: "error",
                    message: "There was an error with player trends: " + err.message,
                };
                dispatch("notification/add", notification_1, {root: true});
            });
    },

    async GetPlayerScoring({commit, dispatch}, payload) {
        commit("SET_TEAM_LOADER", true);

        try {
            const response = await NbaAllTeams.getPlayerScoring(payload);
            commit("SET_SCORING", response.data);
            commit("SET_TEAM_LOADER", false);
        } catch (err) {
            const notification_1 = {
                type: "error",
                message: "There was an error Scoring : " + err.message,
            };
            dispatch("notification/add", notification_1, {root: true});
        }
    },

    updateSavedLineup({commit, dispatch}, payload) {
        NbaAllTeams.updateLineup(payload)
            .then((response) => {
                const notification = {
                    type: "success",
                    message: "Lineup update successfully In Nfl.",
                };
                dispatch("notification/add", notification, {root: true});
            })
            .catch((err) => {
                const notification_1 = {
                    type: "error",
                    message: "There was an error Scoring : " + err.message,
                };
                dispatch("notification/add", notification_1, {root: true});
            });
    },

    async SetProjection({dispatch}, payload) {
        try {
            const res = await common.setProjection(payload);
            if (res.data.success) {
                const notification = {
                    type: "success",
                    message: "Projection update successfully In Nfl.",
                };
                dispatch("notification/add", notification, {root: true});
            }
        } catch (err) {
            const notification_1 = {
                type: "error",
                message: "There was an error set Projection : " + err.message,
            };
            dispatch("notification/add", notification_1, {root: true});
        }
    },

    async FetchSwapPlayer({commit}, payload) {
        try {
            const res = await NbaAllTeams.getPlayerSwap(payload);
            commit("SET_PLAYER_SWAP", res.data);
        } catch (err) {
            console.error("There was an error with Get Players swap: " + err.message);
        }
    },

    async getNbaProps({commit, dispatch}) {
        try {
            const res = await NbaAllTeams.getNbaProps();
            commit("SET_NBA_PROPS", res.data);
            if (res.data.success) {
                const notification = {
                    type: "success",
                    message: "Data fetched successfully In Nba.",
                };
                dispatch("notification/add", notification, {root: true});
            }
        } catch (err) {
            const notification_1 = {
                type: "error",
                message: "There was an error with Nba_props : " + err.message,
            };
            dispatch("notification/add", notification_1, {root: true});
        }
    },

    async getDailyLineup({commit, dispatch}) {
        try {
            commit("SET_LOADING", true);
            const res = await NbaAllTeams.getDailyLineups();
            commit("SET_DAILY_LINEUP", res.data);
            commit("SET_LOADING", false);
            if (res.data?.teams.length === 0) {
                const notification = {
                    type: "info",
                    message: "No Lineups In Nba Yet.",
                };
                dispatch("notification/add", notification, {root: true});
            } else if (res.data.success) {
                const notification = {
                    type: "success",
                    message: "Data fetched Successfully Nba.",
                };
                dispatch("notification/add", notification, {root: true});
            }
        } catch (err) {
            const notification_1 = {
                type: "error",
                message: "There was an error with Nba daily lineup : " + err.message,
            };
            dispatch("notification/add", notification_1, {root: true});
        }
    },

    async getNbaNewsData({commit, dispatch}) {
        commit("SET_LOADING", true);
        try {
            const res = await NbaAllTeams.getNbaNews();
            commit("SET_NBA_NEWS", res.data);
            if (res.data.success) {
                const notification = {
                    type: "success",
                    message: "News fetched successfully In NBA.",
                };
                dispatch("notification/add", notification, {root: true});
            }
            commit("SET_LOADING", false);
        } catch (err) {
            const notification_1 = {
                type: "error",
                message: "There was an error with NBA daily news : " + err.message,
            };
            dispatch("notification/add", notification_1, {root: true});
        }
    },
};

const getters = {
    getTeamLoader(state) {
        return state.getTeamStatus;
    },
    loadingStatus(state) {
        return state.loadingStatus;
    },
    buildTeamLoader(state) {
        return state.teamBuildStatus;
    },
    topPlayersLoader(state) {
        return state.topPlaysStatus;
    },
    userLoader(state) {
        return state.userLoader;
    },

    getStudForDkClsc(state) {
        let studs = [];
        studs.push(
            state.TopStudAndValues.PG_Players,
            state.TopStudAndValues.SG_Players,
            state.TopStudAndValues.SF_Players,
            state.TopStudAndValues.PF_Players,
            state.TopStudAndValues.C_Players
        );

        let newStuds = studs.map((playerPosition) => {
            // //console.log('playerPosition', _.slice(playerPosition, 0, 3));
            return _.slice(playerPosition, 0, 3);
            //   return playerPosition.slice(0, 3);
        });

        let finalStuds = [];
        finalStuds.push(
            ...newStuds[0],
            ...newStuds[1],
            ...newStuds[2],
            ...newStuds[3],
            ...newStuds[4]
        );
        finalStuds = _.uniqBy(finalStuds, "Name");
        return finalStuds;

        // //console.log('studs', studs);
        // //console.log('finalStuds', finalStuds);
    },

    getStudForDkSngl(state) {
        let studs = [];

        studs.push(state.TopStudAndValues.CPT_Players);

        let newStuds = studs.map((playerPosition) => {
            return _.slice(playerPosition, 0, 3);
        });

        let finalStuds = [];
        finalStuds.push(...newStuds[0]);
        finalStuds = _.uniqBy(finalStuds, "Name");
        return finalStuds;
    },

    getStudForFdClsc(state) {
        // debugger;
        let studs = [];

        studs.push(
            state.TopStudAndValues.PG_Players,
            state.TopStudAndValues.SG_Players,
            state.TopStudAndValues.SF_Players,
            state.TopStudAndValues.PF_Players,
            state.TopStudAndValues.C_Players
        );

        let newStuds = studs.map((playerPosition) => {
            return _.slice(playerPosition, 0, 3);
        });

        let finalStuds = [];
        finalStuds.push(
            ...newStuds[0],
            ...newStuds[1],
            ...newStuds[2],
            ...newStuds[3],
            ...newStuds[4]
        );
        finalStuds = _.uniqBy(finalStuds, "Name");
        return finalStuds;
    },

    getStudForFdSngl(state) {
        let studs = [];

        studs.push(state.TopStudAndValues.MVP_Players);

        let newStuds = studs.map((playerPosition) => {
            return _.slice(playerPosition, 0, 3);
        });

        let finalStuds = [];
        finalStuds.push(...newStuds[0]);
        finalStuds = _.uniqBy(finalStuds, "Name");
        console.log("fanduel single", finalStuds);
        return finalStuds;
    },

    NewgetStuds(state, getters) {
        if (state.operator == "DraftKings" && state.operatorGameType == "Classic") {
            return getters.getStudForDkClsc;
        } else if (
            state.operator == "DraftKings" &&
            state.operatorGameType == "Single"
        ) {
            return getters.getStudForDkSngl;
        } else if (
            state.operator == "FanDuel" &&
            state.operatorGameType == "Classic"
        ) {
            return getters.getStudForFdClsc;
        } else if (
            state.operator == "FanDuel" &&
            state.operatorGameType == "Single"
        ) {
            return getters.getStudForFdSngl;
        }
    },

    getValue(state) {
        return state.playersDetail.filter(
            (player) =>
                parseInt(player.FPPDdraftking) < 550 &&
                parseInt(player.FPPDfanduel) < 550
        );
    },

    getSleeper(state) {
        return state.playersDetail.filter(
            (value) =>
                parseInt(value.DraftKingsSalary) < 5000 &&
                parseInt(value.DraftKingsProjection) > 0
        );
    },

    // getValuePlays(state) {
    //   let sleepers = state.playersDetail.filter(
    //     (value) =>
    //       parseInt(value.DraftKingsSalary) < 5000 &&
    //       parseInt(value.DraftKingsProjection) > 0
    //   );
    //   return sleepers;
    // },

    // ? filter by position...
    getFilterBySingle: (state) => (val) => {
        let filterPlayer = [];

        if (val == "CPT") {
            val = "CPT";
        } else if (val == "UTIL") {
            val = "UTIL";
        } else if (val == "Lck/Exl") {
            // debugger;
            filterPlayer = state.playersDetail.filter(
                (_players) =>
                    _players.type.includes("lock") || _players.type.includes("exclude")
            );
            return filterPlayer;
        }

        filterPlayer = state.playersDetail.filter((item) => {
            // //console.log("item", item.OperatorRosterSlots);
            return item.OperatorRosterSlots == val;
        });
        return filterPlayer;
    },

    getFilterByPositionInFanduel: (state) => (val) => {
        let filterPlayers = [];
        if (val == "MVP") {
            state.position = "1";
            return (filterPlayers = state.playersDetail);
        } else if (val == "STAR") {
            state.position = "2";
            return (filterPlayers = state.playersDetail);
        } else if (val == "PRO") {
            state.position = "3";
            return (filterPlayers = state.playersDetail);
        } else if (val == "UTIL") {
            state.position = "4";
            return (filterPlayers = state.playersDetail);
        } else if (val == "UTIL2") {
            state.position = "5";
            return (filterPlayers = state.playersDetail);
        } else if (val == "Lck/Exl") {
            // debugger;
            filterPlayers = state.playersDetail.filter(
                (_players) =>
                    _players.type.includes("lock") || _players.type.includes("exclude")
            );
            return filterPlayers;
        }

        filterPlayers = state.playersDetail.filter((item) => {
            return item.FanDuelPosition == val;
        });
        //console.log('filterPlayers', filterPlayers);
        return filterPlayers;
    },

    getFilterByPosition: (state) => (val) => {
        let filterPlayer = [];
        if (val.includes("PG")) {
            val = "PG";
        } else if (val.includes("SG")) {
            val = "SG";
        } else if (val.includes("SF")) {
            val = "SF";
        } else if (val.includes("PF")) {
            val = "PF";
        } else if (val.includes("C")) {
            val = "C";
        } else if (val.includes("F")) {
            val = "PF";
        } else if (val.includes("G")) {
            val = "PG";
        } else if (val == "Lck/Exl") {
            // debugger;
            filterPlayer = state.playersDetail.filter(
                (_players) =>
                    _players.type.includes("lock") || _players.type.includes("exclude")
            );
            return filterPlayer;
        } else if (val === "UTIL") return (filterPlayer = state.playersDetail);

        filterPlayer = state.playersDetail.filter((item) => {
            if (state.operator == "DraftKings" && item.DraftKingsPosition !== null) {
                return item.DraftKingsPosition.includes(val);
            } else if (state.operator == "FanDuel" && item.FanDuelPosition !== null) {
                return item.FanDuelPosition.includes(val);
            }
        });
        return filterPlayer;
    },
};
export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
